import { Box, Icon, Typography } from '@drone-js/core';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { PriceFormatter, StringFormatter } from '@agoda/react-handyman';
import { LoyaltySearchType } from 'core/type/LoyaltySearch.types';
import { getLoyaltySearchTypeFromLocalStorage } from 'core/utils/loyaltySearchType';
import { PriceWithBadgePointsProps, mapStateToProps } from 'component/common/Price/PriceWithBadgePoints.selectors';
import { isDetailPage } from 'core/constant/analytics/AnalyticsPageType';
import { selectLocaleFromBootstrap } from 'store/slice/bootstrap';

const PriceWithBadgePoints: React.FC<PriceWithBadgePointsProps> = (props) => {
    const { pointBreakup, isMobileScreen, isOptionDisabled, showPointsBadge = true, cms } = props;
    const loyaltySearchType = getLoyaltySearchTypeFromLocalStorage();
    const ssrFlexboxDirection = isMobileScreen ? 'column' : 'row';
    const flexDirection = isDetailPage(props.config.pageConfig.pageTypeId) ? 'column' : ssrFlexboxDirection;

    const locale = useSelector(selectLocaleFromBootstrap);
    const formattedPrice = PriceFormatter.formatToParts(pointBreakup.amount, locale);
    const formattedPriceToString = formattedPrice.map((item) => item.value).join('');

    return (
        <Box mt="8" data-testid="activities-price-with-badge-points">
            <Box display="flex" gap={isMobileScreen ? '8' : '16'} justifyContent="space-between" flexDirection={flexDirection}>
                {showPointsBadge && loyaltySearchType === LoyaltySearchType.EARN && !isOptionDisabled && (
                    <div>
                        <Box borderRadius="2" borderStyle="solid" borderColor="base.default" borderWidth="1" p="4" px="8" width="max-content" alignItems="center" display="flex">
                            <Icon id="fill.symbol.gift" size="14" color="product.primary" me="4" />
                            <Typography data-testid="activities-badge-points" textColor="base.default" variant="caption-default">
                                {' '}
                                {StringFormatter.format(cms[289857], pointBreakup.formattedPoints)}{' '}
                            </Typography>
                        </Box>
                    </div>
                )}
                <div>
                    <Typography textColor={isOptionDisabled ? 'base.disabled' : 'base.default'}>
                        <Typography tag="span" data-testid="activities-currency" variant="caption-default-strong" me="4">
                            {loyaltySearchType === LoyaltySearchType.EARN && pointBreakup.currency}
                            {loyaltySearchType === LoyaltySearchType.BURN && cms[292423]}
                        </Typography>
                        <Typography tag="span" data-testid="activities-price" variant="body-default-strong">
                            {loyaltySearchType === LoyaltySearchType.EARN && formattedPriceToString}
                            {loyaltySearchType === LoyaltySearchType.BURN && pointBreakup.formattedPoints}
                        </Typography>
                    </Typography>
                </div>
            </Box>
        </Box>
    );
};

PriceWithBadgePoints.displayName = 'PriceWithBadgePoints';
export default connect(mapStateToProps)(PriceWithBadgePoints);
